<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                    <van-col span="12">
                        <div class="banner-title">历史月报</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="month-box" v-for="item in menu">
                <div class="month-text">{{item.year}}</div>
                <div class="week-box">
                    <div class="week"
                         v-for="month in item.monthArr"
                         v-if="new Date(month.date) < today && new Date(month.date) > startMonth"
                         @click="toMonthDesc(month.date)"
                    >
                        {{month.month}}
                        <img class="to-icon" src="@/assets/report/weeklyHistory/to.png">
                    </div>
                </div>
            </div>
            <div class="no-tag">下面没有啦~</div>
        </div>
    </div>
</template>


<script>
    import {GetMonth} from '@/utils/dateUtils'
    import {getQueryVariable} from '@/utils/comment'
    export default {

        data() {
            return {
                startMonth: new Date('2023-07-01'),
                endMonth: new Date(),
                today: new Date(GetMonth(0)),
                menu: [],
                userId: getQueryVariable('userId')
            }
        },
        mounted() {
            this.initDate();
        },
        methods: {
            back() {
                this.$router.push({
                    name: 'list',
                    query: {
                        userId: this.userId
                    }
                })
            },
            initDate() {
                let startYear = this.startMonth.getFullYear();
                let endYear = this.endMonth.getFullYear();
                let yearCount = endYear - startYear;
                let menu = [];
                for (let i = 0; i <= yearCount; i++) {
                    let y = startYear + i;
                    menu.push({
                        year: startYear + i,
                        monthArr: [
                            {
                                month: '12月',
                                date: y + '-12'
                            }, {
                                month: '11月',
                                date: y + '-11'
                            }, {
                                month: '10月',
                                date: y + '-10'
                            }, {
                                month: '9月',
                                date: y + '-09'
                            }, {
                                month: '8月',
                                date: y + '-08'
                            }, {
                                month: '7月',
                                date: y + '-07'
                            }, {
                                month: '6月',
                                date: y + '-06'
                            }, {
                                month: '5月',
                                date: y + '-05'
                            }, {
                                month: '4月',
                                date: y + '-04'
                            }, {
                                month: '3月',
                                date: y + '-03'
                            }, {
                                month: '2月',
                                date: y + '-02'
                            }, {
                                month: '1月',
                                date: y + '-01'
                            }
                        ]
                    })
                }
                this.menu = menu.reverse();
            },
            toMonthDesc(month) {
                this.$router.push({
                    name: 'month',
                    query: {
                        userId: this.userId,
                        month
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .content {
        margin-top: 108px;
    }

    .month-box {
        margin-top: 20px;
    }

    .month-text {
        font-size: 14px;
        margin-left: 35px;
        margin-bottom: 15px;
        color: #B3B3B3;
    }

    .week-box {
        width: 345px;
        background: #202020;
        border-radius: 6px 6px 6px 6px;
        margin: 0 auto;
    }

    .week {
        padding-left: 20px;
        font-size: 15px;
        border-bottom: 1px solid #000000;
        line-height: 51px;
        position: relative;
    }

    .to-icon {
        width: 16px;
        position: absolute;
        top: 20px;
        right: 12px;
    }

    .no-tag {
        font-size: 12px;
        text-align: center;
        margin: 30px auto;
    }
</style>




// WEBPACK FOOTER //
// src/views/report/monthHistory.vue